export default {
  data() {
    return {
      privilegeInfo: {}
    }
  },
  methods: {
    go(path, log_id) {
      log_id && this.$log.action(log_id)
      this.$router.push({ path })
    },
    getPrivilegeInfo() {
      this.privilegeInfo = this.$store.state.user.user_info.privilege_info
    }
  },
  mounted() {
    this.getPrivilegeInfo()
    this.$log.page('CCB_web_mangement')
  }
}
